/**
 * @generated SignedSource<<4b670cfd7835ce6be141562df87eac6e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type watches_nativeIssueTable_WatchersCell$data = {
  readonly __typename: "JiraWatchesField";
  readonly watch: {
    readonly count: AGG$Long | null | undefined;
    readonly isWatching: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "watches_nativeIssueTable_WatchersCell";
};
export type watches_nativeIssueTable_WatchersCell$key = {
  readonly " $data"?: watches_nativeIssueTable_WatchersCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"watches_nativeIssueTable_WatchersCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "watches_nativeIssueTable_WatchersCell",
  "selections": [
    {
      "concreteType": "JiraWatch",
      "kind": "LinkedField",
      "name": "watch",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "isWatching"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "JiraWatchesField"
};

(node as any).hash = "093300cbc4b204e418f3c45d4c9b42cb";

export default node;
